<template>
  <v-container>

       <v-layout justify-center>
           <v-card class="ma-0 pa-3 contactCard pt-4 mt-4" style="background-color:white; ">
   <v-toolbar-title class="body-2 grey--text  ml-4 " style="background-color:white; border-bottom:1px solid #efefef" ><h4 class="mt-3 contactTitle"> {{gLang[lang].contact.title}}</h4>  </v-toolbar-title>
       
       <v-layout row wrap>
                  <v-flex class="pa-1" xs12 md6>
                      <v-text-field 
                      v-model="nume" 
                      :error-messages="numeErrors"
                  @input="$v.nume.$touch()"
                   @blur="$v.nume.$touch()"
                     @keydown="errorMessage=''"
                     required
                      :label="gLang[lang].contact.nume"></v-text-field>
                  </v-flex>
                  <v-flex class="pa-1" xs12 md6>
                      <v-text-field 
                      v-model="prenume" 
                      :error-messages="prenumeErrors"
                  @input="$v.prenume.$touch()"
                   @blur="$v.prenume.$touch()"
                     @keydown="errorMessage=''"
                     required
                      :label="gLang[lang].contact.prenume"></v-text-field>
                  </v-flex>
              </v-layout>
              <v-layout row wrap>
                  <v-flex class="pa-1" xs12 md6>
                      <v-text-field 
                      :label="gLang[lang].contact.mail"
                      v-model="email" 
                      :error-messages="emailErrors"
                  @input="$v.email.$touch()"
                   @blur="$v.email.$touch()"
                     @keydown="errorMessage=''"
                  required ></v-text-field>
                  </v-flex>
                  <v-flex class="pa-1" xs12 md6>
                      <v-text-field v-model="telefon" :label="gLang[lang].contact.telefon"></v-text-field>
                  </v-flex>
              </v-layout>
              <v-layout row wrap>
                  <v-flex class="pa-1" xs12>
                      <v-text-field
                    multi-line 
                    v-model="mesaj" 
                      :error-messages="mesajErrors"
                  @input="$v.mesaj.$touch()"
                   @blur="$v.mesaj.$touch()"
                     @keydown="errorMessage=''"
                     required
                    :label="gLang[lang].contact.mesaj"></v-text-field>
                  </v-flex>
                  
              </v-layout>

              <v-layout justify-center row wrap>
                  
                      <v-btn color="primary" @click="sendMessage">{{gLang[lang].messaging.send}}</v-btn>
                  
                  
              </v-layout></v-card>

                  <v-snackbar
      :timeout="timeout"
      :color="colorS"
      :multi-line="mode"
      :vertical="!mode"
      v-model="showSucces"
    >
     {{gLang[lang].contact.successMessage}}
      <v-btn dark flat @click.native="showSucces = false">{{gLang[lang].contact.close}}</v-btn>
    </v-snackbar>

    <v-snackbar
      :timeout="timeout"
      :color="colorF"
      :multi-line="mode"
      :vertical="!mode"
      v-model="showFail"
    >
       {{gLang[lang].contact.failMessage}}
      <v-btn dark flat @click.native="showFail = false">{{gLang[lang].contact.close}}</v-btn>
    </v-snackbar>

       </v-layout>


     
  </v-container>
</template>


<style>
.contactCard {
    width:800px;
}



@media screen and (max-width:800px) {
    .contactCard {
    width:95vw;
}
}


@media screen and (max-width:600px) {
    

.contactTitle{
        font-size:25px;
    }
}
</style>

<script>
import axios from 'axios'
import { validationMixin } from 'vuelidate'
import { required,  email } from 'vuelidate/lib/validators'
export default {

      mixins: [validationMixin],
      validations: {
      nume: { required },
      email: { required, email },
      prenume: { required },
      mesaj: { required },
      
      // repeatPassword: {sameAsPassword: sameAs('password')}
    },
  data() {
      return{
      timeout:6000,
      colorS: 'info',
      colorF:'red',
      mode:true,
          showSucces:false,
          showFail:false,
          contactForm: {
              nume:'',
              prenume:'',
              email:'',
              telefon:'',
              mesaj:''
          },
          nume:'',
          prenume:'',
          email:'',
          telefon:'',
          mesaj:''
      }
  },
methods:{
  sendMessage(){
      var concatMessage=this.nume + " " + this.prenume + " \n" + this.email+ " \n"+ this.telefon + " \n" + "Message:\n\n"+this.mesaj;
      axios.post('/api/messages/email',{message:concatMessage,email:'hera@e-uvt.ro'}).then((response)=>{
          this.showSucces = true;
          this.nume = "";
          this.prenume = "";
          this.email = "";
          this.telefon = "";
          this.mesaj = "";
          this.emailErrors = [];
          this.numeErrors=[];
          this.prenumeErrors = [];
          this.mesajErrors = [];
      }).catch(err=>{
          this.showFail = true;
      })
  }
},
  watch: {
      email( newVal ,oldVal) {
          this.contactForm.email = newVal;
      },
      nume ( newVal ,oldVal) {
          this.contactForm.nume  = newVal;
      },
      prenume( newVal ,oldVal) {
          this.contactForm.prenume = newVal;
      },
      mesaj( newVal ,oldVal) {
          this.contactForm.mesaj = newVal;
      },
  },
  computed : {
       emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.email && errors.push("Must be valid e-mail");
      !this.$v.email.required && errors.push("This field is required!");
      return errors;
    },
    numeErrors () {
        const errors = []
        if (!this.$v.nume.$dirty) return errors
        !this.$v.nume.required && errors.push('This field is required!')
        return errors
      },
      prenumeErrors () {
        const errors = []
        if (!this.$v.prenume.$dirty) return errors
        !this.$v.prenume.required && errors.push('This field is required!')
        return errors
      },
      mesajErrors () {
        const errors = []
        if (!this.$v.mesaj.$dirty) return errors
        !this.$v.mesaj.required && errors.push('This field is required!')
        return errors
      },
      
  }
}
</script>




// WEBPACK FOOTER //
// src/components/Common/Contact.vue